import Page from "@/components/layout/Page";
import useApi from "@/contexts/ApiContext";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import TrainingLayout from "@/components/layout/TrainingLayout";

const ApiTraining = () => {
  const api = useApi();
  const { videoSlug } = useParams();

  const { data: training } = useQuery({ queryKey: ["get-all-api-training"], queryFn: () =>
    api.trainingVideos.getAll("api")
  });

  return (
    <Page title="API training">
      <TrainingLayout training={training} title="API Training" videoSlug={videoSlug} pageSlug="api-training" />
    </Page>
  );
};

export default ApiTraining;